let defaultLocale = 'en-AU';
let defaultCurrency = 'AUD';

export const setTenantFormattingDefaults = ({ locale, currency } = {}) => {
  if (typeof locale === 'string' && locale.trim()) {
    defaultLocale = locale.trim();
  }
  if (typeof currency === 'string' && currency.trim()) {
    defaultCurrency = currency.trim().toUpperCase();
  }
};

export const getTenantLocale = () => defaultLocale;
export const getTenantCurrency = () => defaultCurrency;

const currencyFormatterCache = new Map();

const getCurrencyFormatter = ({ locale, currency, maximumFractionDigits } = {}) => {
  const resolvedLocale = locale || defaultLocale;
  const resolvedCurrency = currency || defaultCurrency;
  const precisionKey =
    typeof maximumFractionDigits === 'number' ? maximumFractionDigits : 'default';
  const cacheKey = `${resolvedLocale}:${resolvedCurrency}:${precisionKey}`;
  if (!currencyFormatterCache.has(cacheKey)) {
    const options = {
      style: 'currency',
      currency: resolvedCurrency,
    };
    if (typeof maximumFractionDigits === 'number') {
      options.maximumFractionDigits = maximumFractionDigits;
    }
    currencyFormatterCache.set(cacheKey, new Intl.NumberFormat(resolvedLocale, options));
  }
  return currencyFormatterCache.get(cacheKey);
};

export const formatMoney = (value, options = {}) =>
  getCurrencyFormatter(options).format(Number(value || 0));

const COUNTRY_UI_CONFIG = {
  AU: {
    locationFilterLabel: 'state',
    locationFilterPluralLabel: 'states',
  },
  NZ: {
    locationFilterLabel: 'region',
    locationFilterPluralLabel: 'regions',
  },
};

const normalizeCountryCode = (value) => {
  const normalized = String(value || '').trim().toUpperCase();
  return COUNTRY_UI_CONFIG[normalized] ? normalized : 'AU';
};

export const getCountryUiConfig = (countryCode) => COUNTRY_UI_CONFIG[normalizeCountryCode(countryCode)];
